export default {
	title: 'Gestión de Dispositivos',
	actions: {
		add: 'Añadir',
		edit: 'Editar',
		delete: 'Eliminar',
		batchDelete: 'Eliminación por Lote',
		save: 'Guardar',
		cancel: 'Cancelar',
		confirm: 'Confirmar'
	},
	messages: {
		deleteSuccess: 'Eliminación exitosa',
		actionSuccess: 'Operación exitosa',
		noValidSensor: 'Por favor, complete al menos una información completa del sensor'
	},
	labels: {
		deviceList: 'Lista de Dispositivos',
		startStopRecord: 'Registro de Inicio-Parada',
		diagnose: 'Diagnosticar',
		node: 'Nodo',
		device: 'Dispositivo',
		sensor: 'Sensor',
		org: 'Organización',
		addNode: 'Añadir {type}',
		editNode: 'Editar {type}'
	},
	table: {
		name: 'Nombre',
		deviceTypeId: 'Tipo de Dispositivo',
		status: 'Estado',
		action: 'Acción'
	},
	form: {
		placeholder: {
			name: 'Por favor, introduzca el nombre',
			deviceTypeId: 'Por favor, seleccione el tipo de dispositivo'
		}
	},
	dialog: {
		add: 'Añadir',
		edit: 'Editar',
		addDevice: 'Añadir Dispositivo',
		addSensor: 'Añadir Sensor',
		addOrg: 'Añadir Organización',
		editDevice: 'Editar Dispositivo',
		editSensor: 'Editar Sensor',
		editOrg: 'Editar Organización'
	},
	buttons: {
		add: 'Añadir',
		edit: 'Editar',
		delete: 'Eliminar',
		save: 'Guardar',
		cancel: 'Cancelar',
		confirm: 'Confirmar',
		diagnose: 'Diagnosticar',
		startStopRecord: 'Registro de Inicio-Parada'
	},
	deviceCom: {
		add: 'Añadir',
		save: 'Guardar',
		addDevice: 'Añadir',
		deviceModelImage: 'Imagen del Modelo del Dispositivo'
	},
	sensorCom: {
		add: 'Añadir',
		save: 'Guardar',
		addSensor: 'Añadir'
	},
	orgCom: {
		save: 'Guardar',
		addOrg: 'Añadir'
	},
	config: {
		gridLayout: 'Diseño de Cuadrícula',
		superiorDepartment: 'Departamento Superior',
		orgPlaceholder: 'Organización (Diagnóstico)',
		name: 'Nombre',
		nameRequired: 'El campo obligatorio no puede estar vacío',
		icon: 'Icono',
		location: 'Ubicación',
		type: 'Tipo',
		label1: 'Etiqueta 1'
	},
	orgTree: {
		expandAll: 'Expandir Todo',
		collapseAll: 'Colapsar Todo',
		filterPlaceholder: 'Ingrese palabras clave para filtrar',
		deleteConfirm: '¿Está seguro de que desea eliminar este nodo?',
		deleteTitle: 'Advertencia'
	},
	index: {
		deviceList: 'Lista de Dispositivos',
		startStopRecord: 'Registro de Inicio-Parada',
		nodeTitle: {
			device: 'Dispositivo',
			sensor: 'Sensor',
			org: 'Organización',
			node: 'Nodo'
		},
		addNodeTitle: 'Añadir {type}',
		editNodeTitle: 'Editar {type}'
	}
}
